import { LOCAL_STORAGE_KEYS } from 'ts/constants/local-storage-keys';

export const isLocalStorageAvailable = (): boolean => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEYS.TEST_KEY, 'true');
    localStorage.removeItem(LOCAL_STORAGE_KEYS.TEST_KEY);
    return true;
  } catch {
    return false;
  }
};
